export default "__VITE_ASSET__Cd0dJUEn__"